export default __webpack_public_path__ + "maps-examples-multiple-shapes-1200-4caac9994b9bbf3a4b5d2de5a29af74a.png";